import LegalHero from "../LegalHero";
import "../LegalProse.css";

import SeoHead from "../../../../seo/SeoHead";
import {
  TERMS_PAGE_DESCRIPTION,
  TERMS_PAGE_TITLE,
} from "../../../../seo/siteConfig";

function TermsConditions() {
  return (
    <div>
      <SeoHead
        title={TERMS_PAGE_TITLE}
        description={TERMS_PAGE_DESCRIPTION}
        path="/terms-and-conditions"
      />
      <LegalHero
        title="Terms & Conditions"
        subtitle="Rules that apply when you use our website and services."
      />
      <article className="legal-prose">
        <p className="legal-meta">Last updated: March 2026.</p>

        <section>
          <h2>Agreement</h2>
          <p>
            By accessing or using the SERVED website and services, you agree to
            these terms. If you do not agree, do not use the site or services.
            These are provided as a template only and does not constitute legal
            advice.
          </p>
        </section>

        <section>
          <h2>Services</h2>
          <p>
            SERVED provides DMCA takedown, leak protection, and related services
            as described on the website and in any separate agreement you enter
            with us. Specific scope, fees, and deliverables are governed by your
            contract or order terms where applicable.
          </p>
        </section>

        <section>
          <h2>Your responsibilities</h2>
          <p>You agree to:</p>
          <ul>
            <li>
              Provide accurate information and lawful rights to act on the
              content you ask us to protect.
            </li>
            <li>
              Not misuse the website (including attempting to disrupt, scrape,
              or probe systems without authorisation).
            </li>
            <li>
              Comply with applicable laws and third-party platform rules when
              using our services.
            </li>
          </ul>
        </section>

        <section>
          <h2>Intellectual property</h2>
          <p>
            The SERVED name, branding, and website content are owned by Served
            Ltd. or its licensors. You may not copy or use them except as
            permitted by law or with our written consent.
          </p>
        </section>

        <section>
          <h2>Disclaimer and limitation</h2>
          <p>
            The website and any general information on it are provided “as is”.
            To the fullest extent permitted by law, we disclaim warranties not
            expressly stated in a written agreement. Our liability is limited as
            set out in your service agreement or, where none applies, to the
            minimum extent allowed by law.
          </p>
        </section>

        <section>
          <h2>Changes</h2>
          <p>
            We may update these terms from time to time. Continued use after
            changes constitutes acceptance of the revised terms, except where
            law requires otherwise.
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            For questions about these terms, contact Served Ltd. via the contact
            page on this website.
          </p>
        </section>
      </article>
    </div>
  );
}

export default TermsConditions;
